import React from "react";
import { alternativeLabel } from "./alternatives";

// "Try: …" after the zero-result sentence (D18, work package 8). Each button
// is a one-step change the calculator already priced; clicking it changes the
// form and searches again.
export default function AlternativeSuggestions({ alternatives, onTry }) {
  if (!alternatives || !onTry) return null;
  if (alternatives.status === "loading") {
    return <div className="ppe-try ppe-try-loading">Looking for a change that finds products…</div>;
  }
  if (alternatives.status !== "done" || alternatives.list.length === 0) return null;
  return (
    <div className="ppe-try">
      <span className="ppe-try-label">Try:</span>
      {alternatives.list.map((alt) => (
        <button
          key={`${alt.kind}:${alt.value || ""}`}
          type="button"
          className="ppe-try-chip"
          title={`${alt.eligibleProducts} eligible product${alt.eligibleProducts === 1 ? "" : "s"} from ${(alt.lenders || []).length} lender${(alt.lenders || []).length === 1 ? "" : "s"}`}
          onClick={() => onTry(alt)}
        >
          {alternativeLabel(alt)}
        </button>
      ))}
    </div>
  );
}
